import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(app)/_components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(app)/_components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(app)/_components/RoutePrefetcher.tsx");
